<template>
  <Navbar :url="imgurl" />
  <div v-if="error">{{ error }}</div>
  <div v-if="post" class="post">
    <h3>{{ post.title }}</h3>
    <span class="pill" v-for="tag in post.tags" :key="tag">{{ tag }}</span>
    <span class="name">Written By {{ post.userName }}</span>
    <span class="created"><i class="fas fa-clock"></i>{{ formatDate }}</span>
    <p class='pre'>{{ post.body }}</p>
    <button v-if="ownership" @click.prevent="handleDelete" class='delete'>Delete post</button>
    <Comments :id="id" />
  </div>
  <div v-else>
    <Spinner/>
  </div>
</template>

<script>
import getPost from '../composables/getPost'
import Spinner from '../components/Spinner'
import Navbar from '../components/Navbar'
import Comments from '../components/Comments'
import getUser from '../composables/getUser'
import { useRoute, useRouter } from 'vue-router'
import { projectFirestore } from '../firebase/config'
import { computed } from 'vue'
import { formatDistanceToNow } from 'date-fns'

export default {
  props: ['id'],
  components: {
    Navbar,
    Spinner,
    Comments
  },
  setup(props){
    const route = useRoute(); // route 是單一路徑上的資訊，可以從useRoute()取得
    const router = useRouter();
    // route.params.id則是傳進該路經的參數
    // const { post, error, load } = getPost(route.params.id);
    const { post, error, load } = getPost(props.id);
    load();
    const { user, imgurl } = getUser();
    const handleDelete = async () => {
      await projectFirestore.collection('posts').doc(props.id).delete();
      router.push('/');
    }
    const ownership = computed(() => {
      return post.value && user.value
    });
    const formatDate = computed(() => {
      return formatDistanceToNow(post.value.createdAt.toDate());
    });
    return { post, error, handleDelete, ownership, formatDate, imgurl }
  }
}
</script>

<style scoped>
  .post {
    max-width: 1200px;
    margin: 0 auto;
  }
  .post p {
    color: #444;
    line-height: 1.5rem;
    margin-top: 40px;
  }
  .post h3 {
    display: block;
    margin-bottom: 2rem;
  }
  .post i {
    padding-right: 6px;
  }
  .post .name {
    display: block;
    margin-top: 12px;
  }
  .pre {
    white-space: pre-wrap;
  }
  button.delete {
    margin: 10px auto;
  }
</style>